import store from '../store/'

export default [
  {
    path: '/makeaclaim',
    name: 'makeaclaim',
    components: { main: () => import(/* webpackChunkName: "makeaclaim" */ '../views/MakeAClaim.vue') },
    meta: {
      checkForUser: true
    },
    redirect: '/makeaclaim/1',
    children: [
      {
        path: '/makeaclaim/1',
        name: 'policylookup',
        beforeEnter (to, from, next) {    
          store.dispatch('resetBeforeMakeAClaim')
          next(next)
        },
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/PolicyLookup.vue') }
      },
      {
        path: '/makeaclaim/3',
        name: 'confirmemail',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ConfirmContact.vue') }
      },
      {
        path: '/makeaclaim/5',
        name: 'incidenttypes',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/IncidentTypes.v2.vue') }
      },
      {
        path: '/makeaclaim/6',
        name: 'aboutYou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/AboutYou.vue') }
      },
      {
        path: '/makeaclaim/8',
        name: 'incidentDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/IncidentDetails.v2.vue') }
      },
      {
        path: '/makeaclaim/10',
        name: 'gadgetlist',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/gadgets/GadgetList.vue') }
      },
      {
        path: '/makeaclaim/101/:id?',
        name: 'gadgetDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/gadgets/GadgetDetails.vue') }
      },
      {
        path: '/makeaclaim/13',
        name: 'declartion',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/Declaration.v2.vue') }
      },
      {
        path: '/makeaclaim/17',
        name: 'reviewv2',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/Review.v2.vue') }
      },
      {
        path: '/makeaclaim/quoteconfirm',
        name: 'quoteconfirm',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ConfirmQuote.vue') }
      },
      {
        path: '/makeaclaim/thankyou',
        name: 'thankyou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ThankYou.v2.vue') }
      },
      {
        path: '/makeaclaim/approved',
        name: 'approved',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ApprovedFastTrack.vue') }
      },
      {
        path: '/makeaclaim/existing',
        name: 'existing',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/ClaimFormList.vue') }
      }
    ]
  },
  {
    path: '/claimsguide',
    name: 'claimsguide',
    components: { main: () => import(/* webpackChunkName: "terms" */ '../views/guide/ClaimsGuide.vue') }
  }
]
// export default [{
//     path: '/makeaclaim',
//     name: 'makeaclaim',
//     components: { main: () => import(/* webpackChunkName: "makeaclaim" */ '../views/MakeAClaim.vue') },
//     meta: {
//       checkForUser: true
//     },
//     redirect: '/makeaclaim/1',
//     children: [
//       {
//         path: '/makeaclaim/saveform',
//         name: 'saveform',
//         beforeEnter (to, from, next) {
//           standaloneClaimForm.methods.saveClaimForm(from)
//         }
//       },
//       {
//         path: '/makeaclaim/1',
//         name: 'policylookup',
//         beforeEnter (to, from, next) {    
//           store.dispatch('resetBeforeMakeAClaim')
//           next(next)
//         },
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/PolicyLookup.vue') }
//       },
//       {
//         path: '/makeaclaim/2',
//         name: 'policydetails',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/PolicyDetails.vue') }
//       },
//       {
//         path: '/makeaclaim/3',
//         name: 'confirmemail',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ConfirmContact.vue') }
//       },
//       {
//         path: '/makeaclaim/5',
//         name: 'incidenttypes',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/IncidentTypes.v2.vue') }
//       },
//       {
//         path: '/makeaclaim/6',
//         name: 'aboutYou',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/AboutYou.vue') }
//       },
//       {
//         path: '/makeaclaim/8',
//         name: 'incidentDetails',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/IncidentDetails.v2.vue') }
//       },
//       {
//         path: '/makeaclaim/10',
//         name: 'gadgetlist',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/gadgets/GadgetList.vue') }
//       },
//       {
//         path: '/makeaclaim/101/:id?',
//         name: 'gadgetDetails',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/gadgets/GadgetDetails.vue') }
//       },
//       {
//         path: '/makeaclaim/13',
//         name: 'declartion',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/Declaration.v2.vue') }
//       },
//       {
//         path: '/makeaclaim/17',
//         name: 'reviewv2',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/Review.v2.vue') }
//       },
//       {
//         path: '/makeaclaim/thankyou',
//         name: 'thankyou',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ThankYou.v2.vue') }
//       },
//       {
//         path: '/makeaclaim/approved',
//         name: 'approved',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/standaloneForm/ApprovedFastTrack.vue') }
//       },
//       {
//         path: '/makeaclaim/resume',
//         redirect: '/myclaims/list'
//       },
//       {
//         path: '/makeaclaim/existing',
//         name: 'existing',
//         components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/ClaimFormList.vue') }
//       }
//     ]
//   }]